'use client';

import React, { FC, JSX, ReactNode } from 'react';
import Image, { StaticImageData } from 'next/image';

import styles from './AuthCard.module.scss';
import { Typographies, Typography } from '@/components/atoms/Typography';
import { Logo } from '@/components/atoms/Logo';
import { AnimateHeight } from '@/components/helpers/AnimateHeight';

type Props = {
  title: string;
  quote: string | JSX.Element;
  img: StaticImageData;
  message?: ReactNode;
  FormComponent: FC;
  FooterComponent?: FC;
};

const AuthCard: FC<Props> = ({ title, quote, img, message = null, FormComponent, FooterComponent }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content__outer}>
        <div className={styles.content__inner}>
          <div className={styles.content__logo}>
            <Logo />
          </div>

          <Typography variant={Typographies.EXPRESSIVE_H2} className={styles.content__title}>
            {title}

            <AnimateHeight in={!!message}>
              <div className={styles.banner}>{message}</div>
            </AnimateHeight>
          </Typography>

          <FormComponent />
        </div>

        {FooterComponent && (
          <div className={styles.content__footer}>
            <FooterComponent />
          </div>
        )}
      </div>

      <div className={styles.background}>
        <Image src={img} className={styles.image} alt="" width={856} height={816} preload={true} quality={75} />
        <Typography variant={Typographies.EXPRESSIVE_H1} className={styles.quote}>
          {quote}
        </Typography>
      </div>
    </div>
  );
};

export { AuthCard };
